/**
 * @generated SignedSource<<9e6c2ddb4cdab642478fec1a9416c6ef>>
 * @relayHash f6314aa271413378cc6a907956a8f3c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d89be6ac69ec20e87d353edcd9c7b4d2e8e5fc3a46a9555ba2d5ceb8bf352a12

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useMarkDialogAsSeenMutation$variables = {
  key: string;
  value: string;
};
export type useMarkDialogAsSeenMutation$data = {
  readonly setOnboardingState: ReadonlyArray<{
    readonly value: string | null | undefined;
  }> | null | undefined;
};
export type useMarkDialogAsSeenMutation = {
  response: useMarkDialogAsSeenMutation$data;
  variables: useMarkDialogAsSeenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "key"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "value"
              }
            ],
            "kind": "ObjectValue",
            "name": "states.0"
          }
        ],
        "kind": "ListValue",
        "name": "states"
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "setOnboardingState",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMarkDialogAsSeenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMarkDialogAsSeenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d89be6ac69ec20e87d353edcd9c7b4d2e8e5fc3a46a9555ba2d5ceb8bf352a12",
    "metadata": {},
    "name": "useMarkDialogAsSeenMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3dadf7831715f454e511403477edc50d";

export default node;
